<template>
  <div class="website-home-content">
    <div class="info">
      <div class="center-box">
        <div class="img-box">
          <div class="img">
            <img src="../../assets/info-img.png" alt="">
          </div>
        </div>
        <div class="info-box">
          <div class="title">云软件管家</div>
          <div class="desc">海量软件 畅享下载 绿色安全</div>
          <div>版本：V2.0.2.1 大小：162MB 更新时间：2024-04-11</div>
          <div class="btn" @click="handleDownload">立即下载</div>
          <div>适用于win7及以上全部系统</div>
        </div>
      </div>
    </div>
    <div class="advantage">
      <div class="center-box">
        <div class="title">云软件管家优势</div>
        <div class="desc">下载安装升级卸载 海量应用 一站管理</div>
        <div class="card-list">
          <div class="item" v-for="(item, i) in advantageList" :key="i">
            <div class="img">
              <img :src="require(`../../assets/advant-${i + 1}.png`)" alt="">
            </div>
            {{ item }}
          </div>
        </div>
        <div class="title pt-0">云软件管家界面展示</div>
        <div class="desc">办公软件/游戏娱乐/精美壁纸 海量资源一网打尽</div>
        <div class="banner">
          <img :src="require(`../../assets/banner-${active + 1}.png`)" alt="">
          <div class="btn left" @click="next(-1)">
            <i class="el-icon-arrow-left"></i>
          </div>
          <div class="btn right" @click="next(1)">
            <i class="el-icon-arrow-right"></i>
          </div>
          <ul>
            <li :class="active === i && 'active'" v-for="(v, i) in 6" :key="i"></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="pdf">
      <div class="center-box">
        <div class="title pt-82">新增PDF文件格式转换</div>
        <div class="desc">支持PDF文件与Office文件、图片等文件互转格式</div>
        <img class="pdf-img" src="../../assets/pdf-img.png" alt="">
      </div>
    </div>
    <div class="green">
      <div class="center-box">
        <div class="title">海量软件 畅享安装 绿色安全</div>
        <div class="img">
          <img src="../../assets/green-img.png" alt="">
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="logo-box">
        <div class="b-l">
          <img src="../../assets/bottom-logo.png" alt="">
        </div>
        <div class="btn" @click="handleDownload">立即下载</div>
      </div>
      <span class="text" @click="handleClick('/user')">用户协议</span>
      <span class="text-n">|</span>
      <span class="text" @click="handleClick('/privacy')">隐私协议</span>
      <span class="text-n">|</span>
      ICP备案号：京ICP备18056025号-1丨版权所有：北京小树发芽网络科技有限公司
    </div>
  </div>
</template>

<script>
export default {
  name: "WebsiteHome",
  components: {
    
  },
  data() {
    return {
      advantageList: ['海量正版软件', '升级提示服务', '一键安装卸载', 'PDF文件格式转换', '精美壁纸一键设置', '超多游戏试玩'],
      active: 0
    };
  },
  computed: {
    
  },
  created() {
    
  },
  methods: {
    handleDownload() {
      const url = 'https://down.xsfaya.com/download/setup_2.0.2.1.exe'
      window.location.href = url
    },
	  handleClick(params) {
      location.href = this.$BASE_URL + params
    },
    next(num) {
      if(this.active === 0 && num === -1) {
        this.active = 6
      }
      if(this.active === 5 && num === 1) {
        this.active = -1
      }
      this.active = this.active + num
    }
  },
};
</script>

<style lang="less" scoped>
img {
  cursor: default;
}
.website-home-content {
  .center-box {
    width: 1438px;
    margin: 0 auto;
    display: flex;
  }
  .title {
    font-size: 40px;
    font-weight: 700;
    padding: 71px 0 18px;
  }
  .desc {
    font-size: 24px;
  }
  .pt-0 {
    padding-top: 0;
  }
  .pt-82 {
    padding-top: 82px;
  }
  .info {
    width: 100%;
    height: 625px;
    background: url('../../assets/info-bg.png') no-repeat;
    background-size: 100%;
    padding-top: 63px;
    .img-box {
      width: 738px;
      height: 494px;
      border-radius: 16px;
      background-color: #83b3f1;
      padding: 9px 9px 7px;
      margin-right: 116px;
      .img {
        width: 720px;
        height: 477px;
      }
    }
    .info-box {
      padding-top: 70px;
      color: #FFFFFF;
      min-width: 378px;
      font-size: 16px;
      .title {
        font-size: 40px;
        font-weight: 700;
      }
      .desc {
        font-size: 30px;
        margin: 16px 0;
      }
      .btn {
        margin: 34px 0 10px;
        font-size: 28px;
        font-weight: 700;
        color: #507AFC;
        background-color: #fff;
        border-radius: 10px;
        width: 260px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        cursor: pointer;
        &:hover {
          background-color: #3662EC;
          color: #fff;
        }
      }
    }
  }
  .advantage {
    width: 100%;
    height: 1384px;
    background: url('../../assets/advantage-bg.png') no-repeat;
    background-size: 100%;
    .center-box {
      display: inherit;
      text-align: center;
    }
    .card-list {
      display: flex;
      margin: 76px 0 69px;
      .item {
        width: 207px;
        height: 205px;
        background: rgba(255,255,255,.4);
        box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.3);
        border-radius: 20px;
        font-size: 22px;
        font-weight: 700;
        padding-top: 48px;
        margin-right: 39px;
        &:last-child {
          margin: 0;
        }
        .img {
          margin: 0 69px 16px 63px;
          width: 75px;
          height: 75px;
        }
      }
    }
    .banner {
      position: relative;
      width: 792px;
      height: 535px;
      margin: 43px auto;
      .btn {
        width: 100px;
        height: 100px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        color: #444444;
        font-size: 56px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &:hover {
          color: #507AFC;
        }
      }
      .left {
        left: -174px;
      }
      .right {
        right: -174px;
      }
      ul {
        list-style: none;
        display: flex;
        justify-content: center;
        margin-top: 43px;
        li {
          width: 14px;
          height: 10px;
          background-color: #507AFC;
          opacity: .4;
          margin-right: 10px;
          border-radius: 6px;
          &.active {
            width: 22px;
            opacity: 1;
          }
        }
      }
    }
  }
  .pdf {
    width: 100%;
    height: 792px;
    background: url('../../assets/pdf-bg.png') no-repeat;
    background-size: 100%;
    .center-box {
      display: inherit;
      text-align: center;
    }
    .pdf-img {
      margin-top: 67px;
      width: 1200px;
      height: 450px;
    }
  }
  .green {
    width: 100%;
    height: 839px;
    background: url('../../assets/green-bg.png') no-repeat;
    background-size: 100%;
    .center-box {
      display: inherit;
      text-align: center;
    }
    .title {
      padding: 61px 0 53px;
    }
    .img {
      width: 910px;
      height: 642px;
      margin: 0 auto;
    }
  }
  .bottom {
    height: 213px;
    width: 1398px;
    margin: 0 auto;
    text-align: center;
    font-size: 14px;
    .logo-box {
      width: 100%;
      height: 164px;
      display: flex;
      justify-content: space-between;
      padding: 40px 0 38px;
      .b-l {
        width: 267px;
        height: 100%;
      }
      .btn {
        font-size: 28px;
        font-weight: 700;
        background-color: #507AFC;
        color: #fff;
        border-radius: 10px;
        width: 260px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        cursor: pointer;
        &:hover {
          background-color: #3662EC;
        }
      }
    }
    .text {
      cursor: pointer;
      &:hover {
        color: #507AFC;
      }
    }
    .text-n {
      margin: 10px;
    }
  }
}
</style>
